export default __webpack_public_path__ + "static/banner_bg-d9df0d0a9edf5249055ffa6fcae07f2a.png";